<template>
	<dialog-form
		:value="value"
		@input="$emit('input', $event)"
		:title="$localize('SendStatusUpdate.title')"
		@commit="save"
		:allow-continue="false"
		:loading="loading"
		loading-skeleton="list-item-avatar-two-line@4, list-item-two-line, image"
		:action-text="
			$localize('SendStatusUpdate.button.sendProjectNotification')
		"
		action-icon="mdi-email-send"
	>
		<send-email-form
			v-model="data.email"
			:relation-id="data.relationId"
			:contact-id="data.contactId"
			@nav="nav"
		/>
	</dialog-form>
</template>

<script>
import DialogForm from '@/shared/components/DialogForm'
import SendEmailForm from '../components/steps/SendEmailForm'
import { isGuid } from '@/services/validation'
import sendCommand from '@/services/sendCommand'
import { prepareStatusUpdateEmail } from '@/services/api'
import Vue from 'vue'

export default {
	components: { DialogForm, SendEmailForm },
	props: {
		value: {
			type: Boolean,
			default: false,
		},
		projectId: {
			validator: isGuid,
		},
	},
	data() {
		return {
			data: {},
			saving: false,
			loading: false,
		}
	},
	async created() {
		this.loading = true
		const { result, ok } = await prepareStatusUpdateEmail.call({
			args: { projectId: this.projectId },
		})

		if (ok) {
			this.data = result
		}
		this.loading = false
	},
	methods: {
		async save(callback) {
			const result = await sendCommand('SendStatusUpdate', {
				projectId: this.projectId,
				email: this.data.email,
			})

			if (result.success) {
				this.$emit('saved')
			}

			callback({ success: result.success })
		},
		nav(to) {
			this.$emit('input', false)
			Vue.nextTick(() => {
				this.$router.push(to)
			})
		},
	},
}
</script>
